<template>
    <div class="fixed z-[100] inset-0 w-screen h-screen bg-white">
        <!--   backdrop-filter backdrop-blur-sm    -->
        <div class="flex flex-col h-screen justify-center items-center">
            <div class="flex justify-center items-center w-20 h-20">
                <!-- <lottie-animation path="src/assets/loading.json" /> -->
                <img src="../../../assets/Gif/animation_500_l92nhj3b.gif" />
            </div>
            <!-- <p class="mt-1">{{ loadingMessage }}</p> -->
        </div>
    </div>
</template>

<script>
// import LottieAnimation from "lottie-vuejs/src/LottieAnimation.vue";

export default {
    // components: { LottieAnimation },
};
</script>

<style></style>
